import './Precompiled';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { checkCountry } from './CheckCountry';
import styled from 'styled-components';
import StoreCountry from '@Stores/StoreCountry';
import App from './App';
import { observer } from 'mobx-react-lite';
import { StorageExtend } from '@Utils/StorageManager';
import { isSomething } from '@Utils/Utils';
import { lowerCase } from '@Utils/String';
import md5 from 'crypto-js/md5';
import { getParameterByName } from '@Configs/ConfigsHeader';
import { language } from '@Language';
import axios from 'axios';
import Spinner from '@Spinner';
import LoadingBar from '@Components/LoadingBar/LoadingBar';
import { storeAPI } from '@Stores/StoreAPI';

// sessionStorage.removeItem('menu')
// sessionStorage.removeItem('menuGroupA-desktop')
// sessionStorage.removeItem('menuGroupA-mobile')
// sessionStorage.removeItem('menuGroupB-desktop')
// sessionStorage.removeItem('menuGroupB-mobile')

const WebSkeleton = styled.div`
    width: ${window.innerWidth}px;
    height: ${window.innerHeight}px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Root = observer(props => {

    const [webReady, setWebReady] = useState(false)
    const [showCountryPortal, setShowCountryPortal] = useState(null)

    function checkForceClear() {
        try {
            // -- Versioning for Developers --
            const VERSION_DEV = md5('1.6.0').toString()
            const clearStorageThenSetVersion = () => {
                console.log('%cForced clean storage.', 'font-weight: bold; color: red;')
                localStorage.clear()
                sessionStorage.clear()
                StorageExtend.set(VERSION_DEV, 'development.version')
                window.location.reload()
                throw 'reload'
            }
            const preVersionDev = StorageExtend.get('development.version')
            if (isSomething(preVersionDev)) {
                if (preVersionDev !== VERSION_DEV) {
                    clearStorageThenSetVersion()
                }
            }
            const versionStr = ''.concat('——————————————————————————————————————————————————')
            console.log('%c' + versionStr, 'font-weight: bold; color: blue;')
            if (process.env.NODE_ENV === 'development') {
                console.log('%cEnvironment: ' + process.env.NODE_ENV, 'font-weight: bold; color: red;')
            } else {
                console.log('%cEnvironment: ' + process.env.NODE_ENV, 'font-weight: bold; color: green;')
            }
            // ----------------------------------
        } catch (error) {
            if (error === 'string') {
                throw '- Found new development version, reload is required.'
            }
        }
    }

    useEffect(() => {
        checkForceClear()
        storeAPI.MainApiStartLoad.country = true
        if (getParameterByName('language')) {
            sessionStorage.setItem('redirect-language', getParameterByName('language'))
        }

        if (/\?autoLogin=/.test(window.location.search)) {
            setWebReady(true)
            setShowCountryPortal(false)

            setTimeout(() => {
                storeAPI.IsMainApiLoaded.country = true
                storeAPI.MainApiStartLoad.country = false
            }, 500)

        } else {

            setTimeout(() => {
                storeAPI.IsMainApiLoaded.country = true
                storeAPI.MainApiStartLoad.country = false
            }, 500)
            document.title = `UNICITY (Office)`
            StorageExtend.set('office', 'development.memoized-country')
            setWebReady(true)
            axios.get(`https://member-calls2.unicity.com/settings/country/enable`).then((response) => {
                if (response.status === 200) {
                    StoreCountry.init(response.data)
                }
            })
        }

    }, [])

    return <>
        <>
            <LoadingBar />
            {storeAPI.IsMainApiLoaded.country === true  && (
                <div style={storeAPI.IsCoreReady === false && showCountryPortal === false ? { visibility: 'hidden' } : {}}>
                    <App {...props} showCountryPortal={showCountryPortal} />
                </div>
            )}
        </>
    </>
})

ReactDOM.render(<Root />, document.getElementById('root'))